var exports = {
  "Y": "x9245d464--e113fa--sort-button",
  "f": "x9245d464--e113fa--sort-icon",
};

module.exports = exports;
